import React from "react";

import { Editor } from "~/components/code/editor";
import { FormField } from "~/components/form/field";

import type { FormState } from "../_form-state";

import { useYamlForm } from "./_use-yaml-form";

export interface SetupDashboardWidgetYamlProps {
	form: FormState;
}

export const SetupDashboardWidgetYaml: React.FC<SetupDashboardWidgetYamlProps> = ({ form }) => {
	const unit = useYamlForm(form);

	return (
		<FormField state={unit}>
			{(scope, field) => (
				<Editor
					height="auto"
					language="yaml"
					onChange={(input) => field.setInput(input)}
					value={field.getInput(scope)}
				/>
			)}
		</FormField>
	);
};
